/**
 * 地図上のツールチップ（Leafletの Tooltip 相当）
 *
 * InfoWindow はスタイル制約が強く動作も重いため、
 * 透明な AdvancedMarker の上に自前のHTMLを描画して実現する。
 * position を更新し続ければ Leaflet の `sticky` ツールチップと同じ追従表示になる。
 */

import { AdvancedMarker } from '@vis.gl/react-google-maps'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** 他のマーカーより手前に出すための z-index */
const TOOLTIP_Z_INDEX = 9999
/** 吹き出しの下端を座標に合わせ、指し示す位置の真上に表示する（anchorLeft/anchorTop はコンテンツをずらす量なので負値） */
const ANCHOR_LEFT = '-50%'
const ANCHOR_TOP = '-100%'

type MapTooltipProps = {
  /** null の間は非表示 */
  position: google.maps.LatLngLiteral | null
  children: ReactNode
  className?: string
}

export function MapTooltip({ position, children, className }: MapTooltipProps) {
  if (!position) return null

  return (
    <AdvancedMarker
      position={position}
      anchorLeft={ANCHOR_LEFT}
      anchorTop={ANCHOR_TOP}
      zIndex={TOOLTIP_Z_INDEX}
      clickable={false}
    >
      <div
        className={cn(
          'pointer-events-none rounded-md border bg-white px-2 py-1 shadow-md',
          'text-xs whitespace-nowrap text-gray-900',
          className,
        )}
      >
        {children}
      </div>
    </AdvancedMarker>
  )
}
